import { logger } from "./logger";
import { StorageArray } from "./StorageArray";
import { NavigationEventType } from "./types/NavigationEventType";
import { PageEnterDetail } from "./types/PageEnterDetail";

type PageEnterEvent = {
  type: NavigationEventType;
  url: string;
  detail?: PageEnterDetail;
};

if (typeof window !== "undefined") {
  logger.debug("Initializing ascript");

  const jsArray = new StorageArray<{
    event: NavigationEventType;
    detail?: PageEnterDetail;
    locationHref: string;
    documentReferrer: string;
    timestamp: number;
    formattedTimestamp?: string;
  }>("jsArray");
  (window as any).jsArray = jsArray;

  logger.debug("Created jsArray");

  logger.debug("Setting up __fscript_callbacks");

  (window as any).__fscript_callbacks = [
    (event: PageEnterEvent) => {
      let locationHref = event.url;
      let documentReferrer =
        localStorage.getItem(
          sessionStorage.getItem("fscrtip_session") + "__last_known_loaded_page"
        ) || document.referrer;

      if (
        event.type === "browser_back" ||
        event.type === "browser_forward" ||
        event.type === "page_load" ||
        event.type === "page_reload"
      ) {
        locationHref =
          localStorage.getItem(
            sessionStorage.getItem("fscrtip_session") +
              "__last_known_loaded_page"
          ) || "";
        documentReferrer =
          localStorage.getItem(
            sessionStorage.getItem("fscrtip_session") +
              "__page_before_last_known_loaded"
          ) || document.referrer;
      }

      let timestamp = new Date();

      if (event.type !== "page_load") {
        timestamp = new Date(timestamp.getTime() - 1);
      }

      jsArray.push({
        event: event.type,
        detail: event.detail,
        locationHref,
        documentReferrer,
        timestamp: timestamp.getTime(),
        formattedTimestamp: timestamp
          .toISOString()
          .replace("T", " ")
          .replace("Z", ""),
      });
    },
  ];

  logger.debug("__fscript_callbacks set");

  if (typeof (window as any).FScript !== "undefined") {
    const fscript = (window as any).FScript;

    logger.debug("FScript detected");

    logger.debug("Processing FScript triggered events");

    if (
      "triggeredEvents" in fscript &&
      fscript.triggeredEvents instanceof Map
    ) {
      // {type: string, url: string, detail?: string}
      const triggeredEvents = fscript.triggeredEvents as Map<
        NavigationEventType,
        boolean
      >;

      logger.debug(
        `FScript triggeredEvents found: ${triggeredEvents.size} events`
      );

      triggeredEvents.forEach((triggered, event) => {
        if (!triggered) return;

        logger.debug(`Processing triggered event: ${event}`);

        let locationHref = location.href;
        let documentReferrer =
          localStorage.getItem(
            sessionStorage.getItem("fscrtip_session") +
              "__last_known_loaded_page"
          ) || document.referrer;

        if (
          event === "browser_back" ||
          event === "browser_forward" ||
          event === "page_load" ||
          event === "page_reload"
        ) {
          locationHref =
            localStorage.getItem(
              sessionStorage.getItem("fscrtip_session") +
                "__last_known_loaded_page"
            ) || "";
          documentReferrer =
            localStorage.getItem(
              sessionStorage.getItem("fscrtip_session") +
                "__page_before_last_known_loaded"
            ) || document.referrer;
        }
        let timestamp = new Date();

        if (event !== "page_load") {
          timestamp = new Date(timestamp.getTime() - 1);
        }

        jsArray.push({
          event,
          locationHref,
          documentReferrer,
          timestamp: timestamp.getTime(),
          formattedTimestamp: timestamp
            .toISOString()
            .replace("T", " ")
            .replace("Z", ""),
        });
      });
    }
  }
}
